import React, {useEffect, useState} from 'react';
import { useMediaQuery } from 'usehooks-ts';
import Stages from '../Stages';
import Result from '../Result';
import Side from '../Side';

import styles from './styles.module.scss';

const Results = ({ stage, setStage, stages, recommendation, setRecommendation, downloadOnly }) => {
  const isDesktop = useMediaQuery('(min-width: 1325px)');
  const [showResult, setShowResult] = useState(false);

  const startOver = () => {
    window.location.replace(window.location.pathname);
  }

  useEffect(() => {
    const checkJsonLoaded = () => {
      if (window.translation_json) {
        setShowResult(true);
      } else {
        setTimeout(() => {
          checkJsonLoaded();
        }, 100);
      }
    };

    checkJsonLoaded();
  }, []);

  return <div className={styles.container}>
    <div className={styles.left_side + ' ' + styles.devices}>
      <Side
        stage={stage}
        startOver={startOver}
      />
    </div>
    {isDesktop ? '' : <div className={styles.stages_container + ' ' + ('both' === recommendation ? styles.stages_container_full : '')}>
      <div className={styles.stages}>
        <Stages
          stages={stages}
          setStage={setStage}
          currentStage={stage}
          recommendation={recommendation}
          currentStep={{key: null}}
        />
      </div>
    </div>}
    <div className={styles.section_content}>
      <div className={styles.content}>
        {showResult ? <Result
          stages={stages}
          setStage={setStage}
          recommendation={recommendation}
          setRecommendation={setRecommendation}
          downloadOnly={downloadOnly}
        /> : ''}
      </div>
    </div>
    {isDesktop ? <div className={styles.stages_container}>
      <div className={styles.stages}>
        <Stages
          stages={stages}
          setStage={setStage}
          currentStage={stage}
          recommendation={recommendation}
          currentStep={{key: null}}
        />
      </div>
    </div> : ''}
  </div>;
}

export default Results;
